import { DepositDto } from "@/api/paymentApi";

/**
 * Resolves a merchant-friendly failure message for a failed/cancelled payout.
 *
 * Payouts store the raw payfac reason code (e.g. Adyen's "counterpartyAccountNotFound")
 * in `error_code`, while `error_reason` is usually empty. We translate known codes to
 * readable copy and fall back to a generic message for unmapped codes.
 *
 * @param vm the Vue instance, used for i18n lookups ($t / $te)
 * @param deposit the payout/deposit whose failure reason we want to display
 */
export function resolvePayoutFailureMessage(vm: any, deposit: DepositDto): string {
  if (deposit?.error_reason) {
    return deposit.error_reason;
  }

  const code = deposit?.error_code;
  if (code) {
    const key = `deposits.failure.reasons.${code}`;
    if (vm.$te(key)) {
      return vm.$t(key);
    }
  }

  return vm.$t("deposits.failure.genericMessage");
}
